import { css } from '@emotion/react'
import { Spacing, cssVar, ThemedColors } from '@opallabs/gem'

export const searchContainer = css({
  padding: `${Spacing.S}px ${Spacing.XS}px 0`,

  backgroundColor: cssVar(ThemedColors.Surface1),

  '+ ul[role="listbox"]': {
    paddingTop: `${Spacing.XS}px`,
  },
})
